var _sodipodiNamedview, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTennis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "tennis.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 4.3994184,
    inkscapeCx: 23.75314,
    inkscapeCy: 81.94265,
    "inkscapWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 7.3489437,10.363623 c 0.08537,-0.185208 0.172156,-0.3714745 0.255411,-0.5545662 l 0.01199,-0.025753 c 0.238477,-0.485775 0.544689,-1.0131778 0.910519,-1.4499167 l -3.908072,0.5341056 c -0.356306,0.04833 -0.652286,0.2988028 -0.759178,0.6420556 l -1.053042,3.3887837 c -0.152047,0.487891 0.12065,1.006828 0.609247,1.158522 0.09137,0.02858 0.18415,0.04233 0.275167,0.04233 0.394758,0 0.760589,-0.254705 0.883709,-0.651581 l 0.878416,-2.825044 1.895828,-0.258939",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.500853,11.552837 C 20.379497,11.056832 19.877847,10.75309 19.381136,10.874446 l -3.4417,0.844903 -1.366661,-0.853723 c -0.04269,0.420511 -0.172156,0.84455 -0.388408,1.245659 -0.09031,0.171802 -0.18662,0.344311 -0.286456,0.516114 l 1.392061,0.869597 c 0.148167,0.09278 0.318559,0.140405 0.490361,0.140405 0.07373,0 0.147814,-0.0088 0.220486,-0.02646 l 3.821642,-0.937683 c 0.496711,-0.122061 0.800453,-0.623358 0.678392,-1.120422",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.349672,16.153413 c 1.046692,-1.479198 2.242961,-2.999317 3.019778,-4.481689 0.34678,-0.642762 0.355953,-1.290814 0.176389,-1.7737672 -0.179211,0.032456 -0.360539,0.050447 -0.543631,0.050447 -0.398639,0 -0.786341,-0.077258 -1.152877,-0.2293055 -0.665339,-0.2769306 -1.177926,-0.7739945 -1.507773,-1.3843001 -3.53e-4,0 -7.05e-4,-3.528e-4 -0.0014,-7.056e-4 C 9.8060527,8.1315983 9.0394657,8.986026 8.4475047,10.19182 c -0.871714,1.921581 -1.91135,3.957462 -2.361847,5.923845 l 4.2640253,0.03775",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.697556,29.092949 -0.945798,-6.38563 c -0.05221,-0.35172 -0.253294,-0.664281 -0.552097,-0.856898 l -5.3498753,-3.450519 -3.947584,-0.03528 -1.122891,4.922661 -3.776839,4.785431 c -0.42227599,0.535164 -0.33090599,1.311628 0.204258,1.733903 0.226836,0.179211 0.496358,0.265289 0.764117,0.265289 0.365125,0 0.726369,-0.160867 0.970139,-0.4699 l 3.949347,-5.003448 c 0.113594,-0.144638 0.194028,-0.311855 0.234597,-0.490713 l 0.899936,-3.946526 5.3661043,3.460751 0.863599,5.832827 c 0.09066,0.613128 0.618067,1.0541 1.219906,1.0541 0.06033,0 0.121003,-0.0046 0.182033,-0.01376 0.674864,-0.09984 1.140531,-0.72778 1.041048,-1.402292",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.349239,7.3297343 C 14.793261,8.6674678 13.385325,9.354679 12.204578,8.8639651 11.024183,8.3732512 10.517947,6.8905263 11.073925,5.5527923 c 0.556331,-1.338439 1.964267,-2.024944 3.144661,-1.533878 1.180747,0.490362 1.686983,1.972734 1.130653,3.31082",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.634145,6.4414403 c -0.662869,0.662869 -1.510594,1.058333 -2.268008,1.058333 -0.316442,0 -0.765175,-0.07126 -1.105959,-0.412397 -0.739422,-0.739422 -0.443794,-2.284942 0.645936,-3.373967 0.662517,-0.662517 1.510242,-1.057981 2.268009,-1.057981 0.316089,0 0.764822,0.07161 1.105958,0.412045 0.73907,0.739422 0.443089,2.284942 -0.645936,3.373967 z m 1.300339,-4.02837 c -0.447322,-0.447675 -1.055864,-0.684036 -1.760361,-0.684036 -1.012825,0 -2.077861,0.484716 -2.923117,1.329619 -1.320094,1.320095 -1.684161,3.148542 -0.937331,4.313767 l -3.318227,3.2476727 c -0.183092,0.178505 -0.185914,0.471664 -0.0074,0.654403 0.09102,0.09278 0.210608,0.139347 0.330905,0.139347 0.11677,0 0.233892,-0.0441 0.32385,-0.131939 l 3.320346,-3.2490837 c 0.394406,0.2582336 0.871362,0.3933475 1.402998,0.3933475 1.012472,0 2.077508,-0.4850695 2.922764,-1.3299725 1.469319,-1.469319 1.75895,-3.570111 0.645583,-4.683125",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30.155323,12.620696 c 0,0.719667 -0.583142,1.303161 -1.302808,1.303161 -0.719314,0 -1.302456,-0.583494 -1.302456,-1.303161 0,-0.719314 0.583142,-1.302809 1.302456,-1.302809 0.719666,0 1.302808,0.583495 1.302808,1.302809",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/tennis.c036d12eaf42ba1867735118eca2e68c.svg";
export { ForwardRef as ReactComponent };